import script from "./SidebarMeasure.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarMeasure.vue?vue&type=script&setup=true&lang=js"

import "./SidebarMeasure.vue?vue&type=style&index=0&id=08ccb99b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08ccb99b"]])

export default __exports__